// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_style_header__YvI1G","logo":"Header_style_logo__3vojG","info":"Header_style_info__1eYKQ","title":"Header_style_title__139NF","des":"Header_style_des__EMZUC"};